(function () {
  /**
   * @deprecated Please use src2/core/models/fulfillmentEvent/FulfillmentEvent.js
   *
   * @ngdoc factory
   * @name FulfillmentEvent
   * @description Model factory for fulfillment event objects.
   */
  angular
    .module('binky.core.fulfillment-events')
    .factory('FulfillmentEvent', getFulfillmentEventModel);

  /* @ngInject */
  function getFulfillmentEventModel(
    _,
    binkySrc2,
    feature,
    FulfillableItemList,
    objectUtils,
    Offer
  ) {
    class FulfillmentEvent {
      /**
       * @constructs FulfillmentEvent
       * @description Constructor for FulfillmentEvent model objects.
       * @param {Object} options Wrapper object for FulfillmentEvent properties.
       */
      constructor(options) {
        if (!_.isUndefined(options)) {
          applyResource(this, options);
        }
      }

      /**
       * @description Method to get the sorted offer names for this fulfillment
       *  event.
       *
       * @returns {string[]} Array of offer names sorted alphabetically.
       */
      getSortedOfferNames() {
        const offerNames = _(this.offerMetadata)
          .map((offer, idx) => _.get(this.offerMetadata, `[${idx}].merchandising.copy.name`))
          .compact()
          .value();
        return offerNames.sort();
      }

      toFulfillmentReturnItems() {
        return _.map(this.offers, (offer) => {
          const acceptedTermsForOffer = {
            acceptedAgreement: 'INITIAL',
            contractId: offer.contractId,
          };
          return {
            acceptedTerms: acceptedTermsForOffer,
            offerId: offer.offerId,
            originalExternalItemId: offer.externalItemId,
            quantity: offer.quantity,
          };
        });
      }

      /**
       * @description Method to get the minimum object representation of this
       *  model.
       * @returns {Object} Object representing this fulfillment event's properties.
       */
      toMinimumModel() {
        return toMinimumObject(this);
      }

      /**
       * @description Method to construct a FulfillmentEvent from the JIL API
       *  response.
       *
       * @param {Object} fulfillmentEvent - a single fulfillment event.
       * @returns {FulfillmentEvent} reference to an FulfillmentEvent object.
       */
      static apiResponseTransformer(fulfillmentEvent) {
        return new FulfillmentEvent(fulfillmentEvent);
      }
    }
    return feature.isEnabled('temp_react_port_fulfillment_event')
      ? binkySrc2.models.fulfillmentEvent.FulfillmentEvent
      : FulfillmentEvent;

    function applyResource(fulfillmentEvent, resource) {
      fulfillmentEvent.offerMetadata = _.map(
        resource.offer_metadata,
        (offer) => new Offer(_.cloneDeep(offer))
      );
      angular.extend(
        fulfillmentEvent,
        toMinimumObject(objectUtils.keysToCamelCase(_.toPlainObject(resource)))
      );

      // Transforming the fulfillableItemList of the offerMetadata so that we can
      // determine summary labels.
      _.forEach(fulfillmentEvent.offerMetadata, (offer) => {
        if (_.has(offer, 'product_arrangement.fulfillable_items')) {
          offer.product_arrangement.fulfillableItemList = new FulfillableItemList(
            objectUtils.keysToCamelCase(_.cloneDeep(offer.product_arrangement.fulfillable_items))
          );
          // Applying the type property as fulfillableItemType so that getQuotaTypeItems call will
          // work as expected.
          _.forEach(offer.product_arrangement.fulfillableItemList.items, (item) => {
            item.fulfillableItemType = item.type;
          });
          delete offer.product_arrangement.fulfillable_items;
        }
      });
      return fulfillmentEvent;
    }

    function toMinimumObject(object) {
      return _.pick(object, [
        'external_request_id',
        'fcTime',
        'fnTime',
        'fulfillmentId',
        'lastFeTime',
        // Omitting offerMetadata because they need to be transformed into Offers without having
        // their properties turned into camelcase.
        'offers',
        'originalFulfillmentId',
        'ownerId',
        'requestId',
        'requestor',
        'requestType',
        'status',
      ]);
    }
  }
})();
